export default "__VITE_ASSET__9ecc1010__"